export default {
      id: "block_other-usage",
      viewBox: "0 0 232.45 263.09",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#block_other",
      toString: function () {
        return this.url;
      }
    }